import { toMutableList20rdgwi7d3cwi as toMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function copiedInterceptors($this) {
  return toMutableList($this.interceptors_1);
}
function copyInterceptors($this) {
  $this.interceptors_1 = copiedInterceptors($this);
  $this.shared_1 = false;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.SharedArrayList_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var PhaseContentClass;
function PhaseContent() {
  if (PhaseContentClass === VOID) {
    class $ {
      constructor(phase, relation, interceptors) {
        return new.target.new_io_ktor_util_pipeline_PhaseContent_6d9x0e_k$(phase, relation, interceptors);
      }
      static new_io_ktor_util_pipeline_PhaseContent_6d9x0e_k$(phase, relation, interceptors) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.phase_1 = phase;
        $this.relation_1 = relation;
        $this.interceptors_1 = interceptors;
        $this.shared_1 = true;
        return $this;
      }
      static new_io_ktor_util_pipeline_PhaseContent_24bg4y_k$(phase, relation) {
        Companion_getInstance();
        var tmp = Companion_getInstance().SharedArrayList_1;
        var $this = this.new_io_ktor_util_pipeline_PhaseContent_6d9x0e_k$(phase, relation, isInterface(tmp, KtMutableList()) ? tmp : THROW_CCE());
        // Inline function 'kotlin.check' call
        if (!Companion_getInstance().SharedArrayList_1.isEmpty_y1axqb_k$()) {
          var message = 'The shared empty array list has been modified';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return $this;
      }
      get_isEmpty_zauvru_k$() {
        return this.interceptors_1.isEmpty_y1axqb_k$();
      }
      get_size_woubt6_k$() {
        return this.interceptors_1.get_size_woubt6_k$();
      }
      addInterceptor_jvll3j_k$(interceptor) {
        if (this.shared_1) {
          copyInterceptors(this);
        }
        this.interceptors_1.add_utx5q5_k$(interceptor);
      }
      addTo_h97ksk_k$(destination) {
        var interceptors = this.interceptors_1;
        if (destination instanceof ArrayList()) {
          destination.ensureCapacity_wr7980_k$(destination.get_size_woubt6_k$() + interceptors.get_size_woubt6_k$() | 0);
        }
        var inductionVariable = 0;
        var last = interceptors.get_size_woubt6_k$();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination.add_utx5q5_k$(interceptors.get_c1px32_k$(index));
          }
           while (inductionVariable < last);
      }
      sharedInterceptors_rmg8b1_k$() {
        this.shared_1 = true;
        return this.interceptors_1;
      }
      toString() {
        return 'Phase `' + this.phase_1.name_1 + '`, ' + this.get_size_woubt6_k$() + ' handlers';
      }
    }
    initMetadataForClass($, 'PhaseContent');
    PhaseContentClass = $;
  }
  return PhaseContentClass;
}
//region block: exports
export {
  PhaseContent as PhaseContent20yhla4zqpd2q,
};
//endregion

//# sourceMappingURL=PhaseContent.mjs.map
